import { render, staticRenderFns } from "./deviceReport.vue?vue&type=template&id=683a2d63&scoped=true&"
import script from "./deviceReport.vue?vue&type=script&lang=js&"
export * from "./deviceReport.vue?vue&type=script&lang=js&"
import style0 from "./deviceReport.vue?vue&type=style&index=0&id=683a2d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a2d63",
  null
  
)

export default component.exports